import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { localState, STATE_KEYS } from 'utils/local-storage'
import { decryptToken, encryptToken } from '../../utils/crypto'
import { AppConfig } from '../../config/app.config'

type TAuthState = {
  token: string | null;
};

const localAuth = localState.get<{ token?: string }>(STATE_KEYS.AUTH)

const initialState: TAuthState = {
  token: decryptToken(localAuth?.token, AppConfig.get('REACT_APP_SECRET_PASSWORD'))
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth (state, action: PayloadAction<{ token: string }>) {
      state.token = action.payload.token

      localState.set(STATE_KEYS.AUTH, {
        token: encryptToken(action.payload.token, AppConfig.get('REACT_APP_SECRET_PASSWORD'))
      })
    },
    unsetAuth: (state) => {
      state.token = null

      localState.delete(STATE_KEYS.AUTH)
    }
  }
})

export const {setAuth, unsetAuth} = authSlice.actions
export default authSlice
